import ModalLayout from 'components/Modals/ModalLayout';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import usePropertyRequestsStore from 'store/propertyRequestsStore';
interface Props {
    visible: boolean;
    onClose: () => void;
    filterTitle?: string;
}

export default function SavedSearchFilter({ visible, onClose, filterTitle }: Props) {
    const { propertyRequestQueryFilter, savedFilters, setSavedFilters, setSelectedFilter } = usePropertyRequestsStore();
    const { register, handleSubmit, watch, setValue } = useForm<{ name: string }>({
        defaultValues: {
            name: filterTitle || '',
        },
    });

    const onSubmit: SubmitHandler<{ name: string }> = (data) => {
        const filterIndex = savedFilters.findIndex((filter) => filter.title === filterTitle);

        let updatedFilters: Record<string, any>[];
        if (filterIndex !== -1) {
            updatedFilters = [...savedFilters];
            updatedFilters[filterIndex] = {
                ...updatedFilters[filterIndex],
                title: data.name,
            };
        } else {
            const newFilter = {
                title: data.name,
                filters: propertyRequestQueryFilter,
            };
            updatedFilters = [...savedFilters, newFilter];
            setSelectedFilter(data.name);
        }

        setSavedFilters(updatedFilters);
        onClose();
    };
    const handleDelete = () => {
        const updatedFilters = savedFilters.filter((filter) => filter.title !== filterTitle);
        setSavedFilters(updatedFilters);
        onClose();
    };

    const isDisabled = watch('name').length < 2 || watch('name').length > 20;
    useEffect(() => {
        setValue('name', filterTitle || '');
    }, [filterTitle]);
    return (
        <ModalLayout visible={visible} showCloseIcon onClose={onClose}>
            <form className="md:w-[650px]  p-4 bg-white rounded-md" onSubmit={handleSubmit(onSubmit)}>
                <h1 className="absolute top-0 left-0 pt-4 px-4 font-medium text-xl font-poppins">Saved Search Preference</h1>
                <div className=" relative mt-12 w-full">
                    <label htmlFor="name" className="font-medium font-poppins text-lg">
                        Name
                    </label>
                    <input
                        type="text"
                        placeholder="e.g. Client request in palmo"
                        className="w-full px-3 py-4 mb-4 mt-2 border rounded-md border-gray-300 "
                        {...register('name')}
                        minLength={2}
                        maxLength={20}
                    />
                    <span className="absolute right-3 top-[58%] -translate-y-1/2 text-gray-400 text-lg px-2">0/20</span>
                </div>

                <div className={`flex items-center gap-2 mt-10  ${!filterTitle ? 'justify-end' : 'justify-between'}`}>
                    {filterTitle && (
                        <button className="font-medium font-poppins text-lg text-my-red" type="button" onClick={handleDelete}>
                            Delete
                        </button>
                    )}
                    <button
                        className={`font-medium font-poppins text-lg text-white bg-black py-2.5 px-7 rounded-lg ${isDisabled ? 'opacity-50' : ''}`}
                        type="submit"
                        disabled={isDisabled}
                    >
                        Save
                    </button>
                </div>
            </form>
        </ModalLayout>
    );
}
